<template>
  <v-select
    :items="statusPedidos"
    label="Status do Pedido"
    item-text="text"
    item-value="value"
    multiple
    chips
    v-model="statusSelecionado"
  />
</template>

<script>
export default {
  name: 'FiltroStatusPedido',
  data() {
    return {
      statusPedidos: [
        {
          value: 0,
          text: 'Recusado'
        },
        {
          value: 1,
          text: 'Atendido'
        },
        {
          value: 2,
          text: 'Pendente'
        },
        {
          value: 3,
          text: 'Saiu para entrega'
        },
        {
          value: 4,
          text: 'Entregue'
        },
        {
          value: 5,
          text: 'Cancelado'
        },
        {
          value: 6,
          text: 'Erro no pagamento'
        }
      ],
      statusSelecionado: [1, 3, 4]
    }
  },
  watch: {
    statusSelecionado() {
      this.emitirStatusSelecionado()
    }
  },
  mounted() {
    this.emitirStatusSelecionado()
  },
  methods: {
    emitirStatusSelecionado() {
      this.$emit('filtrar-status-pedido', {
        status_pedidos: this.statusSelecionado
      })
    }
  }
}
</script>
